module.exports = __webpack_public_path__ + "static/media/slack.b40361f6.png";